// extracted by mini-css-extract-plugin
module.exports = {"form":"new-topic_form__1yqTn","infoMessage":"new-topic_infoMessage__XhYrh","input":"new-topic_input__11rw3","button":"new-topic_button__G2YkO"};